<template>
  <div class="flex items-center space-x-2 my-2" v-if="typeof this.totalPages == 'number'">
    <!-- First Button -->
    <button :disabled="currentPage === 1" @click="changePage(1)"
      class="px-2 py-1 border rounded text-gray-700 dark:text-dark-50 border-gray-200 dark:border-dark-600">
      First
    </button>
    <!-- Previous Button -->
    <button :disabled="currentPage === 1" @click="changePage(currentPage - 1)"
      class="px-2 py-1 border rounded text-gray-700 dark:text-dark-50 border-gray-200 dark:border-dark-600">
      Prev
    </button>

    <!-- Page Buttons -->
    <button v-for="page in visiblePages" :key="page" :class="[
      'px-2 py-1 border rounded',
      (page === currentPage) ? 'bg-primary-500 dark:bg-primary-500 text-black dark:text-dark-50 border-gray-200 dark:border-dark-600' : 'bg-white dark:bg-dark-900 text-black dark:text-dark-50 border-gray-200 dark:border-dark-600'
    ]" @click="changePage(page)" :disabled="page === currentPage || page === '...'">
      {{ page }}
    </button>

    <!-- Next Button -->
    <button :disabled="currentPage === totalPages" @click="changePage(currentPage + 1)"
      class="px-2 py-1 border rounded text-gray-700 dark:text-gray-300 border-gray-200 dark:border-dark-600">
      Next
    </button>
    <!-- Last Button -->
    <button :disabled="currentPage === totalPages" @click="changePage(totalPages)"
      class="px-2 py-1 border rounded text-gray-700 dark:text-gray-300 border-gray-200 dark:border-dark-600">
      Last
    </button>

    <div v-if="withPerPage" class="flex items-center space-x-2 my-2">
      <label class="text-sm text-gray-700 dark:text-dark-50">Show:</label>
      <select :value="perPage" @change="changePerPage($event.target.value)"
        class="px-2 py-1 border rounded text-gray-700 dark:text-dark-50 border-gray-200 dark:border-dark-600">
        <option :value="totalRecords">All</option>
        <option value="10">10</option>
        <option value="25">25</option>
        <option value="50">50</option>
        <option value="100">100</option>
      </select>
    </div>
  </div>
</template>

<script>
export default {
  name: "PaginationButtons",
  props: {
    modelValue: {
      type: Number,
      required: true,
    },
    totalPages: {
      required: true,
    },
    visibleRange: {
      type: Number,
      default: 5, // Number of pages to show around the current page
    },
    perPage: {
      type: Number,
      default: 10,
    },
    totalRecords: {
      type: Number,
      required: true,
    },
    withPerPage: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:modelValue", "update:perPage"],
  computed: {
    currentPage() {
      return this.modelValue;
    },
    visiblePages() {
      const range = this.visibleRange;

      let minStart = 0;
      let maxEnd = 0;
      let start = 0;
      let end = 0;
      let naturalRange = true;
      console.log(this.currentPage);

      minStart = this.currentPage - Math.floor(range / 2);
      maxEnd = this.currentPage + Math.floor(range / 2) - (range % 2 == 1 ? 0 : 1);
      if (minStart < 1) {
        start = 1;
        end = Math.min(range, this.totalPages);
        naturalRange = false;
      } else {
        if (naturalRange) {
          start = minStart;
          end = maxEnd;
        }
      }
      if (maxEnd > this.totalPages) {
        start = Math.max(this.totalPages - range + 1, 1);
        end = this.totalPages;
        naturalRange = false;
      } else {
        if (naturalRange) {
          start = minStart;
          end = maxEnd;
        }
      }

      // const start = Math.max(1, this.currentPage - range);
      // const end = Math.min(this.totalPages, this.currentPage + range);
      const pages = [];
      if (start > 1) {
        pages.push('...');
      }
      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
      if (end < this.totalPages) {
        pages.push('...')
      }
      return pages;
    },
  },
  methods: {
    changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.$emit("update:modelValue", page);
      }
    },
    changePerPage(value) {
      const newPerPage = value === 'all' ? this.totalRecords : parseInt(value);
      this.$emit("update:perPage", newPerPage);
      // Reset to first page when changing per page
      this.$emit("update:modelValue", 1);
    },
  },
};
</script>

<style>
/* Optional minimal styling */
button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>
